const isProd = typeof window !== "undefined" && window.location.hostname !== "localhost" && window.location.hostname !== "127.0.0.1";
const API_BASE = isProd ? "/api" : "http://localhost:8001/api";
export const BACKEND_URL = isProd ? "" : "http://localhost:8001";

const API_TOKEN = import.meta.env.VITE_API_TOKEN || "";

async function apiGet(path, params) {
  const qs = params instanceof URLSearchParams ? params.toString() : "";
  const url = `${API_BASE}${path}${qs ? `?${qs}` : ""}`;
  const res = await fetch(url, {
    headers: API_TOKEN ? { Authorization: `Bearer ${API_TOKEN}` } : {},
  });
  return res.json();
}

export async function fetchStores(status) {
  const params = new URLSearchParams();
  if (status) params.set("status", status);
  return apiGet("/stores", params);
}

export async function fetchStoreSummaries(storeIds, dates, startDate, endDate) {
  const params = new URLSearchParams();
  if (Array.isArray(storeIds)) params.set("store_ids", storeIds.join(","));
  else if (storeIds) params.set("store_ids", storeIds);
  if (dates) params.set("dates", dates);
  if (startDate) params.set("start_date", startDate);
  if (endDate) params.set("end_date", endDate);
  return apiGet("/store-summaries", params);
}

export async function fetchFootfall(storeIds, dates) {
  const params = new URLSearchParams();
  if (Array.isArray(storeIds)) params.set("store_ids", storeIds.join(","));
  else if (storeIds) params.set("store_ids", storeIds);
  if (Array.isArray(dates)) params.set("dates", dates.join(","));
  else if (dates) params.set("dates", dates);
  return apiGet("/footfall", params);
}

export async function fetchFootfallDaily(storeIds, fromDate, toDate) {
  const params = new URLSearchParams();
  if (Array.isArray(storeIds)) params.set("store_ids", storeIds.join(","));
  else if (storeIds) params.set("store_ids", storeIds);
  if (fromDate) params.set("from", fromDate);
  if (toDate) params.set("to", toDate);
  return apiGet("/footfall-daily", params);
}

export async function fetchFootfallDemographic(storeIds, fromDate, toDate) {
  const params = new URLSearchParams();
  if (Array.isArray(storeIds)) params.set("store_ids", storeIds.join(","));
  else if (storeIds) params.set("store_ids", storeIds);
  if (fromDate) params.set("from", fromDate);
  if (toDate) params.set("to", toDate);
  return apiGet("/footfall-demographic", params);
}

export async function fetchFootfallDirectoryHours(storeId, date) {
  const params = new URLSearchParams();
  if (storeId) params.set("store_id", storeId);
  if (date) params.set("date", date);
  return apiGet("/footfall-directory/hours", params);
}

export async function fetchFootfallDirectory(storeId, date, folder) {
  const params = new URLSearchParams();
  if (storeId) params.set("store_id", storeId);
  if (date) params.set("date", date);
  if (folder) params.set("folder", folder);
  return apiGet("/footfall-directory", params);
}

export async function fetchTrafficDensity(storeIds, date, dateRange = 7) {
  const params = new URLSearchParams();
  if (Array.isArray(storeIds)) params.set("store_ids", storeIds.join(","));
  else if (storeIds) params.set("store_ids", storeIds);
  if (date) params.set("date", date);
  params.set("dateRange", dateRange);
  return apiGet("/traffic-density", params);
}

export async function fetchDensityDwell(storeIds, fromDate, toDate, dateRange = 7) {
  const params = new URLSearchParams();
  if (Array.isArray(storeIds)) params.set("store_ids", storeIds.join(","));
  else if (storeIds) params.set("store_ids", storeIds);
  if (fromDate) params.set("from_date", fromDate);
  if (toDate) params.set("to_date", toDate);
  params.set("date_range", dateRange);
  return apiGet("/density-dwell", params);
}

export async function fetchTrafficDensityDwell(storeIds, fromDate, toDate, dateRange = 7) {
  const params = new URLSearchParams();
  if (Array.isArray(storeIds)) params.set("store_ids", storeIds.join(","));
  else if (storeIds) params.set("store_ids", storeIds);
  if (fromDate) params.set("from_date", fromDate);
  if (toDate) params.set("to_date", toDate);
  params.set("date_range", dateRange);
  return apiGet("/traffic-density-dwell", params);
}

export async function fetchSOP(storeIds, startDate, endDate, page = 1, pageSize = 10) {
  const params = new URLSearchParams();
  if (Array.isArray(storeIds)) params.set("store_ids", storeIds.join(","));
  else if (storeIds) params.set("store_ids", storeIds);
  if (startDate) params.set("start_date", startDate);
  if (endDate) params.set("end_date", endDate);
  params.set("page", page);
  params.set("page_size", pageSize);
  return apiGet("/sop", params);
}

export async function fetchTableOccupancy(storeId, date) {
  const params = new URLSearchParams();
  if (storeId) params.set("store_id", storeId);
  if (date) params.set("date", date);
  return apiGet("/table-occupancy", params);
}
